import { useEffect, useRef } from "react";
import ProductCarrousel from "./ProductCarrousel";

export default function ProductCard(props){

    const paddingStyle = {
        "paddingLeft": props.isEven ? "125px" : "0px",
        "paddingRight": props.isEven ? "0px" : "125px"
    }

    const cardRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
                }
            });
        });

        if (cardRef.current) {
            observer.observe(cardRef.current);
        }

        return () => {
            if (cardRef.current) {
                // eslint-disable-next-line
                observer.unobserve(cardRef.current);
            }
        };
    }, []);

    return(
        <div className={`paneles-card ${props.isEven ? 'even-flex' : 'uneven-flex'}`} ref={cardRef}
            id={`service-card-${props.index}`}>
            {
                props.isLargeScreen ?
                <>
                    <div className="text-card-paneles">
                        <div className="text-card-paneles-title" style={paddingStyle}>{props.title}</div>
                        <div className="text-card-paneles-description" style={paddingStyle}>{props.description}</div>
                    </div>
                    <div className="img-card-paneles">
                        {
                            props.imgLink.length === 1 ?
                            <img className="img-paneles" src={props.imgLink[0]} alt={`char${props.index}`}/>
                            :
                            <ProductCarrousel imgLink={props.imgLink} index={props.index}/>
                        }          
                    </div>
                </> 
                :
                <>
                    <div className="text-card-paneles-title-movil">{props.title}</div>
                    <div className="text-card-paneles-description-movil">{props.description}</div>
                    {
                        props.imgLink.length === 1 ?
                        <img className="img-paneles-movil" src={props.imgLink[0]} alt={`char${props.index}`}/>
                        :
                        <ProductCarrousel imgLink={props.imgLink} index={props.index}/>
                    }          
                </>
            }
            
        </div>
    );
}